import React from "react";
import Joi from "joi-browser";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import { Tabs, Tab } from "react-bootstrap";
import {
  getOrganization,
  addOrganization,
  updateOrganization,
} from "../../../common/services/auth/organizationService";
import Form from "../../../common/components/form/form";
import Loading from "../../../common/components/loading/loading";
import OrganizationHistory from "./organizationHistory";
import { withTranslation } from "react-i18next";
import OrganizationUserAccounts from "./organizationUserAccounts";
import OrganizationTradingMarkets from "./organizationTradingMarkets";

class Organization extends Form {
  state = {
    data: {
      organizationId: "",
      name: "",
      shortName: "",
      websiteUrl: "",
      active: "",
      eventId: "",
    },
    createdDate: "",
    updatedDate: "",
    errors: {},
    isLoading: true,
    isNew: true,
  };

  schema = {
    organizationId: Joi.string(),
    name: Joi.string().required().label(this.props.t("OrganizationName")),
    shortName: Joi.string().label(this.props.t("OrganizationShortName")),
    websiteUrl: Joi.string()
      .uri()
      .allow(null, "")
      .label(this.props.t("OrganizationWebsite")),
    active: Joi.boolean().label(this.props.t("Active")),
    eventId: Joi.string(),
  };

  async componentDidMount() {
    const { organizationId, isNew } = this.props;
    this.setState({ isNew: isNew });
    var organization = {};

    if (!isNew) {
      organization = await getOrganization(organizationId);
      organization.eventId = uuid();
    } else {
      organization = {
        organizationId: organizationId,
        name: "",
        shortName: "",
        websiteUrl: "",
        active: true,
        eventId: uuid(),
      };
    }
    this.setState({
      data: this.mapToViewModel(organization),
      isLoading: false,
    });

    const dateFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
      hour: "numeric",
      hour12: false,
      minute: "numeric",
      second: "numeric",
    };

    this.setState({
      createdDate: new Date(organization.createdDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
      updatedDate: new Date(organization.updatedDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
    });
  }

  mapToViewModel(organization) {
    return {
      organizationId: organization.organizationId,
      name: organization.name,
      shortName: organization.shortName,
      websiteUrl: organization.websiteUrl,
      active: organization.active,
      eventId: organization.eventId,
    };
  }

  doSubmit = async () => {
    const { t, onRename } = this.props;
    const { isNew } = this.state;

    try {
      const data = { ...this.state.data };
      data.eventId = uuid();
      this.setState({ data: data });

      if (!isNew) {
        await updateOrganization(this.state.data);
        toast.success(t("OrganizationUpdated"));
      } else {
        await addOrganization(this.state.data);
        this.setState({ isNew: false });
        onRename(this.state.data.organizationId, this.state.data.name);
        toast.success(t("OrganizationAdded"));
      }

      this.props.submitCallbackFunction(this.state.data);
    } catch (ex) {
      console.log(t("ErrorSaving"), ex);

      if (ex.response && ex.response.status === 400) {
        var errorList = ex.response.data.errors;
        if (errorList) {
          var errorKeys = Object.keys(ex.response.data.errors);
          errorKeys.forEach(function (key) {
            errorList[key].map((error) => {
              toast.error(t("ErrorSaving") + " " + key + ": " + error);
              return null;
            });
          });
        } else {
          toast.error(t("ErrorSaving") + " " + ex.response.data);
        }
        const errors = { ...this.state.errors };
        errors.Name = ex.response.data;
        toast.error(ex.response.data.errors.title);
        this.setState({ errors });
      }
    }
  };

  render() {
    const { isLoading, isNew, createdDate, updatedDate } = this.state;

    if (isLoading) return <Loading />;

    const { t, organizationId, allowEdit } = this.props;

    return (
      <div className="container-fluid">
        <form className="form-inline" onSubmit={this.handleSubmit}>
          <fieldset disabled={allowEdit ? "" : "disabled"}>
            <div>
              {this.renderSwitch("active", t("Active"))}
              {this.renderInput("name", t("OrganizationName"))}
              {this.renderInput("shortName", t("OrganizationShortName"))}
              {this.renderInput("websiteUrl", t("OrganizationWebsite"))}
              {allowEdit && this.renderButton(t("Save"))}
              <div className="form-footnote">
                {createdDate !== "Invalid Date" && (
                  <div>
                    {t("Created")} {createdDate}
                  </div>
                )}
                {updatedDate !== "Invalid Date" && (
                  <div>
                    {t("Updated")} {updatedDate}
                  </div>
                )}
              </div>
            </div>
          </fieldset>
        </form>
        {!isNew && (
          <div>
            <Tabs
              className="nav-dark nav-tabs-sm"
              defaultActiveKey={1}
              id="organization-tabs"
              mountOnEnter={true}
              unmountOnExit={true}
            >
              <Tab eventKey={1} title={t("UserAccounts")}>
                <OrganizationUserAccounts
                  organizationId={organizationId}
                  allowEdit={allowEdit}
                />
              </Tab>
              <Tab eventKey={2} title={t("TradingMarkets", { ns: "trading" })}>
                <OrganizationTradingMarkets
                  organizationId={organizationId}
                  allowEdit={allowEdit}
                />
              </Tab>
              <Tab eventKey={3} title={t("History")}>
                <OrganizationHistory organizationId={organizationId} />
              </Tab>
            </Tabs>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation(["auth", "trading"])(Organization);


